export const formatCacheTime = (dateString) => {
  if (!dateString) {
    return "No cache date";
  }

  // Accept raw ms timestamp (number or numeric string) or any Date-parseable string
  const ms = typeof dateString === "number" ? dateString : Number(dateString);
  const cacheDate = !isNaN(ms) && ms > 0 ? new Date(ms) : new Date(dateString);

  if (isNaN(cacheDate.getTime())) {
    return "No cache date";
  }

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);

  const cacheDay = cacheDate.toLocaleDateString();
  const todayDay = today.toLocaleDateString();
  const tomorrowDay = tomorrow.toLocaleDateString();

  const time = cacheDate.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  if (cacheDay === todayDay) {
    return `Today at ${time}`;
  } else if (cacheDay === tomorrowDay) {
    return `Tomorrow at ${time}`;
  } else {
    return `${cacheDate.toLocaleDateString()} at ${time}`;
  }
};

export const formatTimeAgo = (timestamp) => {
  const now = new Date();
  let date;

  // Handle different timestamp formats
  if (!timestamp) {
    // Fallback to "just now" instead of showing error
    return "just now";
  }

  if (typeof timestamp.toDate === "function") {
    // Firestore Timestamp object
    date = timestamp.toDate();
  } else if (typeof timestamp === "string") {
    // ISO string or other string format
    date = new Date(timestamp);
  } else if (timestamp instanceof Date) {
    // Already a Date object
    date = timestamp;
  } else if (typeof timestamp === "number") {
    // Unix timestamp in milliseconds
    date = new Date(timestamp);
  } else {
    // Unknown format - fallback to "just now"
    console.warn("Unknown timestamp format:", timestamp);
    return "just now";
  }

  // Validate the date
  if (isNaN(date.getTime())) {
    console.warn("Invalid date from timestamp:", timestamp);
    // Fallback to "just now" instead of showing error
    return "just now";
  }

  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  // Handle future dates (shouldn't happen but just in case)
  if (seconds < 0) {
    return "just now";
  }

  if (seconds < 5) return "just now";
  if (seconds < 60) return `${seconds} sec ago`;

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} min ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hr ago`;

  const days = Math.floor(hours / 24);
  if (days < 30) return `${days} day${days > 1 ? "s" : ""} ago`;

  const months = Math.floor(days / 30);
  if (months < 12) return `${months} month${months > 1 ? "s" : ""} ago`;

  const years = Math.floor(days / 365);
  return `${years} year${years > 1 ? "s" : ""} ago`;
};
